import RfqFilesThumbnailViewer from './RfqFilesThumbnailViewerContainer';

export default RfqFilesThumbnailViewer;
